// extracted by css-extract-rspack-plugin
module.exports =  {"stars":"StarRater-lMxg__stars","star":"StarRater-CSbg__star","stars--medium":"StarRater-s2dk__stars--medium","stars--small":"StarRater-DPVQ__stars--small"};